import React, {useEffect, useState} from 'react';
import PropTypes                    from 'prop-types';
import Tag                          from './Tag';
import {getCommonTranslation}       from '../../utils/TranslationHelper';

function FilterGroup({filter, onClickFilterTag, activeFilter, showFilter, expandFilters}) {
    if (filter.hidden) {
        return null;
    }
    if (filter.hide && activeFilter) {
        const hide = activeFilter.find(item => item.key && filter.hide[item.key] && filter.hide[item.key].includes(item.value.KEY));
        if (hide) {
            return null;
        }
    }

    const [showAll, setShowAll]     = useState(expandFilters);
    const [showArrow, setShowArrow] = useState(false);
    const [maxHeight, setMaxHeight] = useState(39);
    const [minHeight, setMinHeight] = useState(39);

    useEffect(() => {
        setShowAll(expandFilters);
    }, [showFilter]);
    const setRef = (ref) => {
        if (ref && ref.children) {
            // should show arrow
            let sumWidth = 0;
            for (const child of ref.children[0].children) {
                sumWidth += child.getBoundingClientRect().width;
            }

            if (sumWidth > ref.parentElement.getBoundingClientRect().width - 10) {
                if (!ref.children[0].getBoundingClientRect().height) {
                    return;
                }
                // set maxHeight
                const height = ref.children[0].getBoundingClientRect().height + 10;
                setMaxHeight(height);
                setShowArrow(true);
            }
            setMinHeight(ref.children[0].children[0].getBoundingClientRect().height);
        }
    };

    return <div className='content__filter-group'>
        <div className='content__filter-group__headline-container'>
            <span className='content__filter-group__headline'>{filter.headline}</span>
            {showArrow && !expandFilters &&
                    <span className={'content__filter-group__headline-more ' + (showAll ? 'content__filter-group__headline-more--hide-bottom' : '')}
                          onClick={() => setShowAll(!showAll)}>{getCommonTranslation('more')}</span>}
            {showArrow && !expandFilters &&
                    <span className={'content__filter-group__headline-more ' + (showAll ? '' : 'content__filter-group__headline-more--hide-top')}
                          onClick={() => setShowAll(!showAll)}>{getCommonTranslation('less')}</span>}
        </div>
        <div className={'content__filter-list' + (showAll ? '' : ' content__filter-list--hide') + (showArrow && !expandFilters ? ' content__filter-list--more' : '')}
             style={showAll ? {maxHeight: maxHeight + 'px'} : (minHeight > 0 ? {maxHeight: minHeight + 'px'} : {})}
             ref={(ref) => setRef(ref)}>
            <div className='content__filter-list__container'>
                {filter.tags.map((tag, idx) => <Tag key={idx} tag={tag} onClickTag={onClickFilterTag} activeFilter={activeFilter} />)}
            </div>
        </div>
    </div>;
}

FilterGroup.propTypes = {
    filter:           PropTypes.object.isRequired,
    onClickFilterTag: PropTypes.func.isRequired,
    activeFilter:     PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    showFilter:       PropTypes.bool,
    expandFilters:    PropTypes.bool,
};

FilterGroup.defaultProps = {
    expandFilters: false,
};

export default FilterGroup;
